// ** Styled Components
import { IconButton } from '@/shared/ui'
import {
	AllRightsReserved,
	FooterWrapper,
	LogoWrapper,
	RightsWrapper,
	SocialsWrapper
} from './styles'

// ** Icon Imports
import { LinkedIn, LogoNewDark } from '@/shared/ui/icons'

// ** Third Party Imports
import { Link } from 'react-router-dom'

export const FooterNew = () => {
	return (
		<FooterWrapper>
			<LogoWrapper>
				<IconButton
					to='/home'
					icon={<LogoNewDark />}
					width={12}
					height={3}
					ariaLabel='Go to home page'
				/>
			</LogoWrapper>

			<SocialsWrapper>
				<IconButton
					href='https://www.linkedin.com/company/fortunai/'
					icon={<LinkedIn />}
					width={2}
					height={2}
					ariaLabel='Go to LinkedIn'
				/>
			</SocialsWrapper>

			<RightsWrapper>
				<Link to='/privacy-policy'>Privacy Policy</Link>

				<AllRightsReserved>®ALL RIGHTS RESERVED</AllRightsReserved>
			</RightsWrapper>
		</FooterWrapper>
	)
}
